module.exports = __webpack_public_path__ + "slide8.05278d288e04d6840553.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/private/home/slide8.jpg
// module id = ./src/assets/images/private/home/slide8.jpg
// module chunks = main